import { LockOutlined } from '@mui/icons-material';
import { Box, Button, CircularProgress, Container, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PromotionMensualisationSecurityDto } from '../../services/dtos/promotion-mensualisation-security.dto';
import { showAxiosMessageError } from '../../services/error-message.service';
import { useSnackbars } from '../../hooks/snackbar.hook';
import { AxiosError } from 'axios';
import { promotionMensualisationAuth } from '../../services/promotion-mensualisation-security.service';
import { useAuth } from '../../hooks/use-auth.hook';

export default function PromotionMensualisationSecurityPage() {
    const [searchParams] = useSearchParams();

    const token = searchParams.get('token');
    const messageType = searchParams.get('message');

    const [code, setCode] = useState('');

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const auth = useAuth();

    const showMessage = useSnackbars();

    const handleSubmitForm = () => {
        setLoading(true);
        let promotionMensualisationDto: PromotionMensualisationSecurityDto = {
            codeAcces: code,
            captcha: 'captchaToken',
        };

        promotionMensualisationAuth(token, promotionMensualisationDto)
            .then(async response => {
                if (response?.authtoken) {
                    auth.loginWithToken(response.authtoken);
                    if (token) {
                        localStorage.setItem('promotionMensualisationToken', token);
                    }
                } else {
                    localStorage.setItem('codeAcces', code);
                }
                localStorage.setItem('messageType', messageType ?? '5');
                navigate(`/${response.redirect}`, { replace: true });
            })
            .catch((error: Error | AxiosError) => {
                setLoading(false);
                if (error instanceof AxiosError && error?.response?.status === 401) {
                    error.response.status = 400;
                }
                showAxiosMessageError(error, showMessage);
            });
    };

    if (!token) {
        navigate(`/`, { replace: true });
    }

    return (
        <Container maxWidth="xs" sx={{ mt: { xs: 4, md: 15 } }}>
            <Paper sx={{ p: 4, borderRadius: 4, boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)' }}>
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Box
                        sx={{
                            display: 'inline-flex',
                            p: 2,
                            bgcolor: 'rgba(62, 92, 167, 0.1)',
                            borderRadius: '50%',
                            mb: 2,
                        }}
                    >
                        <LockOutlined color="primary" sx={{ fontSize: 32 }} />
                    </Box>
                    <Typography variant="h5" fontWeight={800} color="primary.dark">
                        Accès Sécurisé
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Veuillez saisir le code à 8 chiffres figurant sur votre courrier.
                    </Typography>
                </Box>

                <TextField
                    fullWidth
                    label="Code à 8 chiffres"
                    variant="outlined"
                    placeholder="Ex : 12345678"
                    sx={{ mb: 4 }}
                    value={code}
                    disabled={loading}
                    onChange={e => setCode(e.target.value.replace(/[^0-9]/g, '').substring(0, 8))}
                    inputProps={{
                        style: {
                            textAlign: 'center',
                            letterSpacing: '0.2em',
                            fontWeight: 700,
                        },
                    }}
                />

                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleSubmitForm}
                    disabled={loading || code.length !== 8}
                    sx={{ py: 2, borderRadius: 3, fontWeight: 800 }}
                >
                    {loading ? <CircularProgress size={26} color="inherit" /> : 'VALIDER'}
                </Button>
            </Paper>
        </Container>
    );
}
